<template>
  <a-range-picker
      v-if="info.status === 'edit'"
      style="width: 100%"
      :format="widget.format"
      v-model:value="value"
      separator="-"
      :showTime="showTime"
      :disabled="info.status === 'show'"
      :allowClear="true"
      :ranges="ranges"
      :placeholder="[info.title + '开始', info.title + '结束']"
  />
  <date-range-table v-else :widget="widget" :data="data" :prop-name="propName" :info="info"/>
</template>
<script lang="ts" >
import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'normal', show: 'small'},
});

</script>

<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import dayjs, {Dayjs} from 'dayjs';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {DateRangeFieldType} from "@/components/business/crud/interface/FieldType";
import DateRangeTable from "@/components/business/crud/widgets/impl/DateRangeTable.vue";

const props = defineProps<{
  propName: string;
  widget: DateRangeFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const ranges = {
  一天: [dayjs().subtract(1, 'd'), dayjs()],
  一周: [dayjs().subtract(1, 'w'), dayjs()],
  一个月: [dayjs().subtract(1, 'month'), dayjs()],
}

const showTime = {
  hideDisabledOptions: true,
  defaultValue: [
    dayjs('00:00:00', 'HH:mm:ss'),
    dayjs('23:59:59', 'HH:mm:ss'),
  ],
}

const value = computed({
  get() {
    const param: Dayjs[] = [];
    if (data.value[props.widget.startPropName]) {
      param.push(dayjs(Number(data.value[props.widget.startPropName])));
    }
    if (data.value[props.widget.endPropName]) {
      param.push(dayjs(Number(data.value[props.widget.endPropName])));
    }
    return param;
  },
  set(value: Dayjs[]) {
    data.value[props.widget.startPropName] = value ? value[0]?.valueOf() : undefined;
    data.value[props.widget.endPropName] = value ? value[1]?.valueOf() : undefined;
  },
})

</script>

<style lang="scss" scoped></style>
